import { Dispatch } from "redux";
import { fetchHiddenDocuments } from "../..";
import { ApiConfig } from "../../../../../../config/ApiConfig";
import { Collection } from "../../../../../../models";
import { MoveItemLaneRequest } from "../../../../../../models/MoveLaneRequest";
import { cacheKanbanOperations } from "../../../../../../utils/kanban/cacheOperations";
import { createRequestActionTypes } from "../../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { createRequestThunk, RequestThunkParameters } from "../../../../../../utils/request-actions-helpers/createRequestThunk";
import { AppStateWithData } from "../../../../../AppStateWithData";
import { getGroupForDocument } from "../../../../documentsAdditionalData";

export const moveDocumentBetweenLanesActionTypes = createRequestActionTypes('MOVE_DOCUMENT_BETWEEN_LANES')

export interface MoveCardBetweenLanesAdditionalData {
    isFullview?: boolean
}

export const moveDocumentBetweenLanes = (config: ApiConfig) => (itemMoveRequest: MoveItemLaneRequest, isKanbanMove?: boolean, isFullview?: boolean) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    cacheKanbanOperations.addMoveOp({actionType: 'MoveCard', data: {
        docId: itemMoveRequest.cardId,
        sourceLane: itemMoveRequest.sourceLaneId + '',
        targetLane: itemMoveRequest.targetLaneId + ''
    }})
    const thunkParams: RequestThunkParameters<Collection, MoveItemLaneRequest, MoveCardBetweenLanesAdditionalData> = {
        method: 'PUT',
        url: `${config.API_URL}/collections/moveCard/`,
        requestActionTypes: moveDocumentBetweenLanesActionTypes,
        body: itemMoveRequest,
        actionAdditionalData: {
            isFullview
        },
        processResultBeforeDispatch: (result: Collection) => {
            if (config.updateItem) {
                 config.updateItem(itemMoveRequest.cardId)
            }
            if(!isKanbanMove) {
                if (config.refreshFeed) {
                    config.refreshFeed()
                }
                if(!isFullview && itemMoveRequest.cardId) {
                    dispatch<any>(fetchHiddenDocuments(config)([itemMoveRequest.cardId]))
                }
                if (!isFullview && itemMoveRequest.collectionId) {
                    dispatch<any>(getGroupForDocument(config)(itemMoveRequest.collectionId))
                }
            }
            return result
        }
    }
    
    return dispatch<any>(createRequestThunk(thunkParams, undefined))
}
